import {circleSvg as Icon__small__circleSvg} from '../Icon__small/Icon__small--circle.js'

export var circle = {
  name: 'circle',
  category: 'icon',
  colorable: true,
  svg: Icon__small__circleSvg,
};
